import React from 'react';
import styled from 'styled-components';

import PublicGamesListTool from "../games/tools/PublicGamesListTool";

export default function PublicScenariosApp() {

  return (
    <Wrapper currentName={'scenarios'}>

      <PublicGamesListTool/>

    </Wrapper>
  );
}

const Wrapper = styled.div`

`;